<template>
  <div
    class="new-report"
    :class="{
      'new-report--planned': report.planned,
      'new-report--flash': flash,
    }"
  >
    <!-- NEW REPORT CONTENT -->
    <div
      class="new-wrapper new-wrapper--controlls"
      :class="{ 'new-wrapper-invalid': report.isInvalid }"
    >
      <!-- ROW 1 DESKTOP -->
      <div class="new-content-inputs">
        <!-- ДАТА -->
        <label class="label mobile" for="Date">Дата</label>
        <div class="new-input-wrapper">
          <div class="new-input">
            <span class="mck icon--date">D</span>
            <input
              class="date"
              type="text"
              id="newReportDate"
              placeholder="Дата"
              v-model="formatedDate"
              readonly
            />
            <span class="disabled">A</span>
          </div>
        </div>
        <!-- DESKTOP COMPANY -->
        <div class="new-input-wrapper desktop">
          <div class="new-input" :class="{ 'new-input-disabled': true }">
            <span class="mck icon--company">a</span>
            <input
              type="text"
              placeholder="Име на отдел"
              v-model="report.company.companyName"
            />
            <span class="disabled">A</span>
          </div>
        </div>
        <!-- MOBILE COMPANY -->
        <label class="label mobile" for="company">Отдел</label>
        <div class="new-input mobile">
          <span class="mck icon--company">a</span>
          <!-- SELECTED -->
          <input
            type="text"
            placeholder="Име на отдел"
            v-model="report.company.companyName"
          />
          <span class="disabled">A</span>
        </div>
        <!-- PROJECT -->
        <div class="new-input-wrapper desktop">
          <div class="new-input" :class="{ 'new-input-disabled': true }">
            <span class="mck icon--project">h</span>
            <!-- SELECTED -->
            <input
              type="text"
              placeholder="Име на проект"
              v-model="report.project.projectName"
            />
            <span class="disabled">A</span>
          </div>
        </div>
        <!-- MOBILE PROJECT -->
        <label class="label mobile" for="project">Проект</label>
        <div class="new-input mobile">
          <span class="mck icon--project">h</span>
          <!-- SELECTED -->
          <input
            type="text"
            placeholder="Име на проект"
            v-model="report.project.projectName"
          />
          <span class="disabled">A</span>
        </div>
      </div>
    </div>
    <div
      class="new-wrapper new-wrapper--content"
      :class="{ 'new-wrapper-invalid': report.isInvalid }"
      v-if="viewLists()"
    >
      <div class="new-content">
        <!-- WORKERS / MATERIALS / ACTIVITIES / MECHANIZATIONS -->
        <div
          class="new-content-data-row"
          :class="{ 'new-content-data-row-active': viewLists() }"
        >
          <!-- WORKERS -->
          <div class="new-content-data-item expense">
            <div v-if="viewLists()" class="new-content-data-item-content">
              <table>
                <thead class="new-content-data-item-toggle">
                  <tr title="Редакция на работници">
                    <td>Работници</td>
                    <td v-if="report.initAsPlanned && !report.planned">
                      <span class="desktop">Планирани часове</span>
                    </td>
                    <td>
                      <span class="desktop">
                        <template v-if="report.planned"
                          >Планирано работно време, ч.</template
                        >
                        <template v-else>Отчетени часове</template>
                      </span>
                    </td>
                    <td class="no-min">
                      <span class="desktop">Ставка</span>
                    </td>
                    <td>
                      <span class="desktop">Себестойност на труда</span>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!report.workers.length">
                    <td></td>
                  </tr>
                  <template v-for="(worker, i) in report.workers">
                    <tr
                      :key="`userPart-${i}`"
                      v-if="
                        (report.workers[i - 1]
                          ? report.workers[i - 1].part !== worker.part
                          : true) && worker.part
                      "
                      class="part-tr"
                    >
                      <td>
                        <span class="part-name-span"
                          >ЧАСТ {{ worker.part }}</span
                        >
                      </td>
                      <td></td>
                      <td></td>
                      <td v-if="report.initAsPlanned && !report.planned"></td>
                      <td>
                        <p>{{ getTotalWorkers(worker.part).toFixed(2) }} €</p>
                      </td>
                    </tr>
                    <tr :key="`addedWorker-${i}-${worker._id}`">
                      <td class="ma-cell no-user-select">
                        <!-- ma-cell-name -->
                        <!-- <span class="mck icon--delete"> b </span> -->
                        <span
                          class="mck icon-notVisible"
                          :class="{ 'icon-isVisible': worker.isVisible }"
                          >{{ worker.isVisible ? "r" : "q" }}</span
                        >
                        <div class="name-buttons-wrapper">
                          <p>
                            {{ worker.name }}
                          </p>

                          <section class="tasks-buttons">
                            <div v-if="worker.tasks.length" class="add-remove">
                              <!-- <span class="mck">s</span> -->
                              <span class="number">{{
                                worker.tasks.length
                              }}</span>
                              <!-- <span class="mck">t</span> -->
                            </div>

                            <!-- <span
                              class="mck toggle-tasks"
                              v-if="worker.tasks.length"
                              @click="worker.tasks = []"
                              >u</span
                            > -->
                            <!-- <span class="mck toggle-tasks" v-else>v</span> -->
                          </section>
                        </div>
                        <SelectHour v-model="worker.startHour" />
                        <SelectHour v-model="worker.endHour" />
                      </td>
                      <div v-if="worker.tasks.length" class="tasks">
                        <p>ПОДЗАДАЧИ И ДЕЙНОСТИ</p>

                        <div
                          v-for="(t, i) of worker.tasks"
                          :key="`${t}-${i}`"
                          class="tasks-input-wrapper"
                        >
                          <span class="number">{{ i + 1 }}</span>
                          <input
                            v-model="t.name"
                            placeholder="Описание на задачата"
                            type="text"
                          />

                          <section class="tasks-hours-selection">
                            <SelectHour
                              v-model="t.startHour"
                              :end="worker.endHour"
                              :start="worker.startHour"
                              :selected="
                                worker.tasks.length
                                  ? worker.tasks.map((t) => t.startHour)
                                  : []
                              "
                              :selectedEnd="
                                worker.tasks.length
                                  ? worker.tasks.map((t) => t.endHour)
                                  : []
                              "
                              taskHours="true"
                            />
                            <SelectHour
                              v-model="t.endHour"
                              :end="worker.endHour"
                              :start="worker.startHour"
                              :selected="
                                worker.tasks.length
                                  ? worker.tasks.map((t) => t.startHour)
                                  : []
                              "
                              :selectedEnd="
                                worker.tasks.length
                                  ? worker.tasks.map((t) => t.endHour)
                                  : []
                              "
                              taskHours="true"
                            />
                          </section>
                        </div>
                      </div>
                      <td v-if="report.initAsPlanned && !report.planned">
                        <WorktimeTag
                          :date="report.date"
                          :start="worker.plannedStartHour"
                          :end="worker.plannedEndHour"
                          :planned="true"
                        />
                      </td>
                      <td>
                        <div class="input-and-percent-wrapper">
                          <template
                            v-if="
                              report.initAsPlanned &&
                              !report.planned &&
                              worker.plannedStartHour &&
                              worker.plannedEndHour
                            "
                          >
                            <span
                              class="mck2 worker-hours-toggle"
                              title="Изберете, ако планираният работник не участва в реалния отчет"
                              v-if="worker.startHour && worker.endHour"
                              >7</span
                            >
                            <span
                              class="mck2 worker-hours-toggle"
                              title="Изберете, за да добавите отново планираният работник"
                              v-else
                              >9</span
                            >
                          </template>
                          <span class="mck2 worker-hours-toggle hidden" v-else
                            >9</span
                          >
                          <WorktimeTag
                            :date="report.date"
                            :start="worker.startHour"
                            :end="worker.endHour"
                          />
                          <PercentTag
                            v-if="report.initAsPlanned && !report.planned"
                            :planned="
                              calculateHours(
                                report.date,
                                worker.plannedStartHour,
                                worker.plannedEndHour
                              ).total
                            "
                            :real="
                              calculateHours(
                                report.date,
                                worker.startHour,
                                worker.endHour
                              ).total
                            "
                          />
                        </div>
                      </td>
                      <td class="no-min no-wrap">
                        <template v-if="worker.position"
                          >{{ worker.position.rate }} € &nbsp;&nbsp;&nbsp;({{
                            worker.position.name
                          }})</template
                        >
                        <template v-else>0 €</template>
                      </td>
                      <td class="no-wrap">
                        {{
                          getWorkerCost(
                            worker,
                            calculateHours(
                              report.date,
                              worker.startHour,
                              worker.endHour
                            )
                          )
                        }}
                        €
                      </td>
                    </tr>
                  </template>
                  <tr class="tr-totals">
                    <td
                      :colspan="report.initAsPlanned && !report.planned ? 4 : 3"
                    >
                      <p>Разходи за труд:</p>
                    </td>
                    <td>
                      <p class="tr-totals__expense">
                        {{ getTotalWorkers().toFixed(2) }} €
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- MECHANIZATIONS -->
          <div class="new-content-data-item expense">
            <div v-if="viewLists()" class="new-content-data-item-content">
              <table>
                <thead class="new-content-data-item-toggle">
                  <tr title="Редакция на собствени механизации">
                    <td>Собствени механизации</td>
                    <td
                      class="padding-right"
                      v-if="report.initAsPlanned && !report.planned"
                    >
                      <span class="desktop">Планирана</span>
                    </td>
                    <td>
                      <span class="desktop">
                        <template v-if="report.planned">Планирана</template>
                        <template v-else>Отчетена</template>
                      </span>
                    </td>
                    <td>
                      <span class="desktop">Ед. Цена</span>
                    </td>
                    <td>
                      <span class="desktop">Сума</span>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!report.mechanizations.length">
                    <td></td>
                  </tr>
                  <template v-for="(m, index) in report.mechanizations">
                    <tr
                      :key="`addedReportPart-${index}`"
                      v-if="
                        (report.mechanizations[index - 1]
                          ? report.mechanizations[index - 1].part !== m.part
                          : true) && m.part
                      "
                      class="part-tr"
                    >
                      <td>
                        <span class="part-name-span">ЧАСТ {{ m.part }}</span>
                      </td>
                      <td></td>
                      <td></td>
                      <td v-if="report.initAsPlanned && !report.planned"></td>
                      <td>
                        <p>
                          {{ getTotals("mechanizations", m.part).toFixed(2) }}
                          €
                        </p>
                      </td>
                    </tr>
                    <tr :key="`addedReportMechanization-${index}-${m.name}`">
                      <!-- ma-cell-name -->
                      <td
                        class="ma-cell no-user-select"
                        :class="{ 'ma-cell-additional': m.isAdditional }"
                      >
                        <!-- <span class="mck" v-if="m.isAdditional">O</span> -->
                        <!-- <span class="mck icon--delete"> b </span> -->
                        <span
                          class="mck icon-notVisible"
                          :class="{ 'icon-isVisible': m.isVisible }"
                          >{{ m.isVisible ? "r" : "q" }}</span
                        >
                        <div class="name-buttons-wrapper">
                          <p>
                            {{ m.name }}
                          </p>

                          <section class="tasks-buttons">
                            <div v-if="m.tasks.length" class="add-remove">
                              <!-- <span class="mck">s</span> -->
                              <span class="number">{{ m.tasks.length }}</span>
                              <!-- <span class="mck">t</span> -->
                            </div>

                            <!-- <span
                              class="mck toggle-tasks"
                              v-if="m.tasks.length"
                              @click="m.tasks = []"
                              >u</span
                            > -->
                            <!-- <span class="mck toggle-tasks" v-else>v</span> -->
                          </section>
                        </div>
                        <SelectHour v-model="m.startHour" :end="m.endHour" />
                        <SelectHour v-model="m.endHour" :start="m.startHour" />
                      </td>
                      <div v-if="m.tasks.length" class="tasks">
                        <p>ПОДЗАДАЧИ И ДЕЙНОСТИ</p>

                        <div
                          v-for="(t, i) of m.tasks"
                          :key="`${t}-${i}`"
                          class="tasks-input-wrapper"
                        >
                          <span class="number">{{ i + 1 }}</span>
                          <input
                            v-model="t.name"
                            placeholder="Описание на задачата"
                            type="text"
                          />
                          <section class="tasks-hours-selection">
                            <SelectHour
                              v-model="t.startHour"
                              :end="m.endHour"
                              :start="m.startHour"
                              :selected="
                                m.tasks.length
                                  ? m.tasks.map((t) => t.startHour)
                                  : []
                              "
                              :selectedEnd="
                                m.tasks.length
                                  ? m.tasks.map((t) => t.endHour)
                                  : []
                              "
                              taskHours="true"
                            />
                            <SelectHour
                              v-model="t.endHour"
                              :end="m.endHour"
                              :start="m.startHour"
                              :selected="
                                m.tasks.length
                                  ? m.tasks.map((t) => t.startHour)
                                  : []
                              "
                              :selectedEnd="
                                m.tasks.length
                                  ? m.tasks.map((t) => t.endHour)
                                  : []
                              "
                              taskHours="true"
                            />
                          </section>
                        </div>
                      </div>
                      <td
                        class="ma-cell ma-cell-nowrap padding-right"
                        v-if="report.initAsPlanned && !report.planned"
                      >
                        {{ m.plannedItems || 0 }} {{ m.unit }}
                      </td>
                      <td class="ma-cell ma-cell-nowrap">
                        <div class="input-and-percent-wrapper">
                          <div>
                            <input
                              class="ma-cell-input"
                              v-model="m.items"
                              type="number"
                              min="0"
                            />
                            {{ m.unit }}
                          </div>
                          <PercentTag
                            v-if="report.initAsPlanned && !report.planned"
                            :planned="m.plannedItems"
                            :real="m.items"
                          />
                        </div>
                      </td>
                      <td class="ma-cell ma-cell-nowrap">
                        <input
                          class="ma-cell-input"
                          v-model="m.price"
                          type="number"
                          min="0"
                        />
                        €
                      </td>
                      <td class="ma-cell ma-cell-nowrap">
                        {{ (+m.items * +m.price).toFixed(2) }} €
                      </td>
                    </tr>
                  </template>
                  <tr class="tr-totals">
                    <td
                      :colspan="report.initAsPlanned && !report.planned ? 4 : 3"
                    >
                      <p>Разход за собствена механизация:</p>
                    </td>
                    <td>
                      <p class="tr-totals__expense">
                        {{ getTotals("mechanizations").toFixed(2) }} €
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- RENTED MECHANIZATIONS -->
          <div class="new-content-data-item expense">
            <div v-if="viewLists()" class="new-content-data-item-content">
              <table>
                <thead class="new-content-data-item-toggle">
                  <tr title="Редакция на наети механизации">
                    <td>Наети механизации</td>
                    <td
                      class="padding-right"
                      v-if="report.initAsPlanned && !report.planned"
                    >
                      <span class="desktop">Планирана</span>
                    </td>
                    <td>
                      <span class="desktop">
                        <template v-if="report.planned">Планирана</template>
                        <template v-else>Отчетена</template>
                      </span>
                    </td>
                    <td>
                      <span class="desktop">Ед. Цена</span>
                    </td>
                    <td>
                      <span class="desktop">Сума</span>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!report.rentedMechanizations.length">
                    <td></td>
                  </tr>
                  <template v-for="(m, index) in report.rentedMechanizations">
                    <tr
                      :key="`addedReportPart-${index}`"
                      v-if="
                        (report.rentedMechanizations[index - 1]
                          ? report.rentedMechanizations[index - 1].part !==
                            m.part
                          : true) && m.part
                      "
                      class="part-tr"
                    >
                      <td>
                        <span class="part-name-span">ЧАСТ {{ m.part }}</span>
                      </td>
                      <td></td>
                      <td></td>
                      <td v-if="report.initAsPlanned && !report.planned"></td>
                      <td>
                        <p>
                          {{
                            getTotals("rentedMechanizations", m.part).toFixed(2)
                          }}
                          €
                        </p>
                      </td>
                    </tr>
                    <tr
                      :key="`addedReportRentedMechanization-${index}-${m.name}`"
                    >
                      <td
                        class="ma-cell no-user-select"
                        :class="{ 'ma-cell-additional': m.isAdditional }"
                      >
                        <!-- ma-cell-name -->
                        <!-- <span class="mck" v-if="m.isAdditional">O</span> -->
                        <!-- <span class="mck icon--delete"> b </span> -->
                        <span
                          class="mck icon-notVisible"
                          :class="{ 'icon-isVisible': m.isVisible }"
                          >{{ m.isVisible ? "r" : "q" }}</span
                        >
                        <div class="name-buttons-wrapper">
                          <p>
                            {{ m.name }}
                          </p>

                          <section class="tasks-buttons">
                            <div v-if="m.tasks.length" class="add-remove">
                              <!-- <span class="mck">s</span> -->
                              <span class="number">{{ m.tasks.length }}</span>
                              <!-- <span class="mck">t</span> -->
                            </div>

                            <!-- <span
                              class="mck toggle-tasks"
                              v-if="m.tasks.length"
                              @click="m.tasks = []"
                              >u</span
                            > -->
                            <!-- <span class="mck toggle-tasks" v-else>v</span> -->
                          </section>
                        </div>
                        <SelectHour v-model="m.startHour" :end="m.endHour" />
                        <SelectHour v-model="m.endHour" :start="m.startHour" />
                      </td>
                      <div v-if="m.tasks.length" class="tasks">
                        <p>ПОДЗАДАЧИ И ДЕЙНОСТИ</p>

                        <div
                          v-for="(t, i) of m.tasks"
                          :key="`${t}-${i}`"
                          class="tasks-input-wrapper"
                        >
                          <span class="number">{{ i + 1 }}</span>
                          <input
                            v-model="t.name"
                            placeholder="Описание на задачата"
                            type="text"
                          />
                          <section class="tasks-hours-selection">
                            <SelectHour
                              v-model="t.startHour"
                              :end="m.endHour"
                              :start="m.startHour"
                              :selected="
                                m.tasks.length
                                  ? m.tasks.map((t) => t.startHour)
                                  : []
                              "
                              :selectedEnd="
                                m.tasks.length
                                  ? m.tasks.map((t) => t.endHour)
                                  : []
                              "
                              taskHours="true"
                            />
                            <SelectHour
                              v-model="t.endHour"
                              :end="m.endHour"
                              :start="m.startHour"
                              :selected="
                                m.tasks.length
                                  ? m.tasks.map((t) => t.startHour)
                                  : []
                              "
                              :selectedEnd="
                                m.tasks.length
                                  ? m.tasks.map((t) => t.endHour)
                                  : []
                              "
                              taskHours="true"
                            />
                          </section>
                        </div>
                      </div>
                      <td
                        class="ma-cell ma-cell-nowrap padding-right"
                        v-if="report.initAsPlanned && !report.planned"
                      >
                        {{ m.plannedItems || 0 }} {{ m.unit }}
                      </td>
                      <td class="ma-cell ma-cell-nowrap">
                        <div class="input-and-percent-wrapper">
                          <div>
                            <input
                              class="ma-cell-input"
                              v-model="m.items"
                              type="number"
                              min="0"
                            />
                            {{ m.unit }}
                          </div>
                          <PercentTag
                            v-if="report.initAsPlanned && !report.planned"
                            :planned="m.plannedItems"
                            :real="m.items"
                          />
                        </div>
                      </td>
                      <td class="ma-cell ma-cell-nowrap">
                        <input
                          class="ma-cell-input"
                          v-model="m.price"
                          type="number"
                          min="0"
                        />
                        €
                      </td>
                      <td class="ma-cell ma-cell-nowrap">
                        {{ (+m.items * +m.price).toFixed(2) }} €
                      </td>
                    </tr>
                  </template>
                  <tr class="tr-totals">
                    <td
                      :colspan="report.initAsPlanned && !report.planned ? 4 : 3"
                    >
                      <p>Разход за наета механизация:</p>
                    </td>
                    <td>
                      <p class="tr-totals__expense">
                        {{ getTotals("rentedMechanizations").toFixed(2) }} €
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- MATERIALS -->
          <div class="new-content-data-item expense">
            <div v-if="viewLists()" class="new-content-data-item-content">
              <table>
                <thead class="new-content-data-item-toggle desktop">
                  <tr title="Редакция на материали">
                    <td>Материали</td>
                    <td>
                      <span class="desktop">Количество</span>
                    </td>
                    <td>
                      <span class="desktop">Ед. Цена</span>
                    </td>
                    <td>
                      <span class="desktop">Сума</span>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!report.materials.length">
                    <td></td>
                  </tr>
                  <template v-for="(material, index) in report.materials">
                    <tr
                      :key="`addedReportPart-${index}`"
                      v-if="
                        (report.materials[index - 1]
                          ? report.materials[index - 1].part !== material.part
                          : true) && material.part
                      "
                      class="part-tr"
                    >
                      <td>
                        <span class="part-name-span"
                          >ЧАСТ {{ material.part }}</span
                        >
                      </td>
                      <td></td>
                      <td></td>
                      <!-- <td v-if="report.initAsPlanned && !report.planned"></td> -->
                      <td>
                        <p>
                          {{ getTotals("materials", material.part).toFixed(2) }}
                          €
                        </p>
                      </td>
                    </tr>
                    <tr :key="`addedReportMaterial-${index}-${material.name}`">
                      <td
                        class="ma-cell no-user-select"
                        :class="{ 'ma-cell-additional': material.isAdditional }"
                      >
                        <!-- ma-cell-name -->
                        <!-- <span class="mck" v-if="material.isAdditional">G</span> -->
                        <span
                          class="mck icon-notVisible"
                          :class="{ 'icon-isVisible': material.isVisible }"
                          >{{ material.isVisible ? "r" : "q" }}</span
                        >
                        {{ material.name }}
                      </td>
                      <td class="ma-cell ma-cell-nowrap">
                        <div class="input-and-percent-wrapper">
                          <div>
                            <input
                              class="ma-cell-input"
                              v-model="material.items"
                              type="number"
                              min="0"
                            />
                            {{ material.unit }}
                          </div>
                        </div>
                      </td>
                      <td class="ma-cell ma-cell-nowrap">
                        <input
                          class="ma-cell-input"
                          v-model="material.price"
                          type="number"
                          min="0"
                        />
                        €
                      </td>
                      <td class="ma-cell ma-cell-nowrap">
                        {{ (+material.items * +material.price).toFixed(2) }} €
                      </td>
                    </tr>
                  </template>
                  <tr class="tr-totals">
                    <td colspan="3">
                      <p>Разход за материали:</p>
                    </td>
                    <td>
                      <p class="tr-totals__expense">
                        {{ getTotals("materials").toFixed(2) }} €
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- <div class="invalid-report-wrap" v-if="!report.planned">
            <p>
              <strong>Маркиране на отчет като сгрешен</strong> - ако смятате, че
              сте объркали данните в отчета, го отбележете като грешен. Ще бъде
              видим, но няма да се зачита.
            </p>
            <div class="switch-wrapper">
              <div class="switch-container">
                <label class="switch">
                  <input
                    type="checkbox"
                    v-model="report.isInvalid"
                    @change="reportChanged()"
                    :disabled="!allowSave"
                  />
                  <span class="slider"></span>
                </label>
              </div>
              <label class="switch-label" @click="report.isInvalid = true">
                <img
                  v-if="report.isInvalid"
                  class="flag"
                  src="../assets/img/flag_yes.svg"
                  alt="Invalid"
                />
                <img
                  v-else
                  class="flag"
                  src="../assets/img/flag_no.svg"
                  alt="Valid"
                />
                Грешен отчет
              </label>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="new-wrapper new-wrapper--content" v-else>
      <img class="help-img" src="../assets/img/helpReports.svg" />
    </div>
    <transition name="slide-bottom">
      <ConvertPlannedToRealReport
        v-if="isConvertPlannedToRealReportOpen"
        :report="report"
        @get-report="getReport(), (flash = true)"
        @get-report-moved="getReport()"
      />
    </transition>
  </div>
</template>

<script>
import hours from "./mixins/hours.js";
import SelectHour from "./shared/SelectHour";
import WorktimeTag from "./shared/WorktimeTag";
import PercentTag from "./shared/PercentTag";
import ConvertPlannedToRealReport from "./shared/ConvertPlannedToRealReport";
import { mapGetters } from "vuex";
import log from "./mixins/log.js";
import { bg } from "vuejs-datepicker/dist/locale";
import { format } from "date-fns";

export default {
  components: {
    SelectHour: SelectHour,
    WorktimeTag: WorktimeTag,
    PercentTag: PercentTag,
    ConvertPlannedToRealReport,
  },
  mixins: [hours, log],
  data() {
    return {
      // Vars for select v-model
      company: "",
      project: "",
      // Vars for date picker
      formatedDate: "",
      // A boolean for the modal for workers selection
      isConvertPlannedToRealReportOpen: false,
      // SEARCH
      searchCompanies: "",
      bg: bg,
      searchProjects: "",
      // The main company project
      companies: [],
      latestCompanies: [{ company: { _id: "", companyName: "" } }],
      projects: [],
      selectedProject: undefined,
      allowSave: true,
      flash: true,
      // The main report project
      report: {
        date: undefined,
        planned: false,
        overtime: false,
        createdBy: {
          _id: "",
          name: "",
        },
        company: {
          _id: "",
          companyName: "",
        },
        project: {
          _id: "",
          projectName: "",
        },
        isInvalid: false,
        allVisible: true,
        workers: [],
        materials: [],
        activities: [],
        mechanizations: [],
        rentedMechanizations: [],
      },
    };
  },
  computed: {
    ...mapGetters(["getUser"]),
    getParts() {
      const parts = [];

      for (let m of this.selectedProject.mechanizations) {
        if (m.part) {
          if (parts.indexOf(m.part) === -1) {
            parts.push(m.part);
          }
        }
      }
      for (let m of this.selectedProject.rentedMechanizations) {
        if (m.part) {
          if (parts.indexOf(m.part) === -1) {
            parts.push(m.part);
          }
        }
      }
      for (let m of this.selectedProject.materials) {
        if (m.part) {
          if (parts.indexOf(m.part) === -1) {
            parts.push(m.part);
          }
        }
      }
      for (let mh of this.selectedProject.manHours) {
        if (mh.part) {
          if (parts.indexOf(mh.part) === -1) {
            parts.push(mh.part);
          }
        }
      }
      for (let a of this.selectedProject.activities) {
        if (a.part) {
          if (parts.indexOf(a.part) === -1) {
            parts.push(a.part);
          }
        }
      }

      return parts.sort();
    },
  },
  methods: {
    // We have a selected workers, materials, activities OR mechanizations at least and change styles in template
    viewLists() {
      return (
        this.report.workers.length ||
        this.report.materials.length ||
        this.report.activities.length ||
        this.report.mechanizations.length ||
        this.report.rentedMechanizations.length
      );
    },
    getTotalWorkers(part) {
      let total = 0;
      for (let x of this.report.workers) {
        if (part) {
          if (x.part === part) {
            total += x.total || 0;
          }
        } else {
          total += x.total || 0;
        }
      }

      if (!part) {
        if (!this.report.totals) {
          this.$set(this.report, "totals", {});
        }

        this.$set(this.report.totals, "workers", total);
      }
      return total;
    },
    getWorkerCost(w, h) {
      let rate = 0;

      if (w.position) {
        rate = w.position.rate || 0;
      }

      const hours = h.total || 0;
      this.$set(w, "total", rate * hours);
      return rate * hours;
    },
    getTotals(type, part) {
      let total = 0;
      for (let x of this.report[type]) {
        if (part) {
          if (x.part === part) {
            total += x.items * x.price || 0;
          }
        } else {
          total += x.items * x.price || 0;
        }
      }

      if (!part) {
        if (!this.report.totals) {
          this.$set(this.report, "totals", {});
        }

        this.$set(this.report.totals, type, total);
      }

      return total;
    },
    getExpense(a) {
      let e = 0;
      const total = +a.items * +a.price;
      const totalForPart = this.getExpensesForPart(a.part);
      const totalForActivityPart = this.getTotals("activities", a.part);

      e =
        totalForPart *
        ((total ? total : 1) /
          (totalForActivityPart ? totalForActivityPart : 1));

      this.$set(a, "expense", e);
      return e;
    },
    getExpensesForPart(p) {
      let e = 0;

      e += this.getTotalWorkers(p);
      e += this.getTotals("mechanizations", p);
      e += this.getTotals("rentedMechanizations", p);
      e += this.getTotals("materials", p);

      return e;
    },
    getExpenses() {
      let total = 0;

      total += this.report.totals.workers;
      total += this.report.totals.mechanizations;
      total += this.report.totals.rentedMechanizations;
      total += this.report.totals.materials;

      if (!this.report.totals) {
        this.$set(this.report, "totals", {});
      }

      this.$set(this.report.totals, "expenses", total);

      return total;
    },
    // GETS ONLY VISIBLE WORKERS
    updateWorkers() {
      this.report.workers = this.report.workers.filter((x) => x.isVisible);
    },
    updateMaterials() {
      if (this.report.materials) {
        this.report.materials = this.report.materials.filter(
          (m) => m.isVisible
        );

        this.report.materials.map((m) => {
          const material = this.selectedProject.materials.find((fm) => {
            return fm._id === m._id;
          });
          if (material) {
            material.isSelected = true;
            material.items = m.items;
            material.plannedItems = m.plannedItems;
            material.price = m.price;
            material.part = m.part;
          } else {
            m.isSelected = true;
            this.selectedProject.materials.unshift(m);
          }
        });
      }
    },
    updateActivities() {
      this.report.activities.map((a) => {
        const activity = this.selectedProject.activities.find((fa) => {
          return fa._id === a._id;
        });
        if (activity) {
          activity.isSelected = true;
          activity.items = a.items;
          activity.plannedItems = a.plannedItems;
          activity.price = a.price;
          activity.part = a.part;
        } else {
          a.isSelected = true;
          this.selectedProject.activities.unshift(a);
        }
      });
    },
    updateMechanizations() {
      if (this.report.mechanizations) {
        this.report.mechanizations = this.report.mechanizations.filter(
          (m) => m.isVisible
        );

        this.report.mechanizations.map((m) => {
          const mechanization = this.selectedProject.mechanizations.find(
            (ma) => {
              return ma._id === m._id;
            }
          );
          if (mechanization) {
            mechanization.isSelected = true;
            mechanization.items = m.items;
            mechanization.plannedItems = m.plannedItems;
            mechanization.price = m.price;
            mechanization.part = m.part;
            mechanization.tasks = m.tasks;
          } else {
            m.isSelected = true;
            this.selectedProject.mechanizations.unshift(m);
          }
        });
      }
    },
    updateRentedMechanizations() {
      if (this.report.rentedMechanizations) {
        this.report.rentedMechanizations =
          this.report.rentedMechanizations.filter((m) => m.isVisible);

        this.report.rentedMechanizations.map((m) => {
          const mechanization = this.selectedProject.rentedMechanizations.find(
            (ma) => {
              return ma._id === m._id;
            }
          );
          if (mechanization) {
            mechanization.isSelected = true;
            mechanization.items = m.items;
            mechanization.plannedItems = m.plannedItems;
            mechanization.price = m.price;
            mechanization.part = m.part;
            mechanization.landlord = m.landlord;
            mechanization.tasks = m.tasks;
          } else {
            m.isSelected = true;
            this.selectedProject.rentedMechanizations.unshift(m);
          }
        });
      }
    },
    // GET SPECIFIC PART BY ID REQUEST
    getSelectedProject(id) {
      this.selectedProject = undefined;
      // two seperate routes for logged user and not logged users
      let url = `${process.env.VUE_APP_BASE_URI}/company/${
        this.getUser ? "project" : "external-project"
      }/${id}`;
      return this.$http
        .get(url)
        .then((response) => {
          this.selectedProject = response.data[0];
        })
        .catch((error) => console.log(error));
    },
    // GET SPECIFIC REPORT
    getReport() {
      const id = this.$route.params.id;
      this.isConvertPlannedToRealReportOpen = false;
      let url = `${process.env.VUE_APP_BASE_URI}/report/${id}`;
      this.$http
        .get(url)
        .then((response) => {
          this.getSelectedProject(response.data.project._id).then(() => {
            this.report = response.data;
            this.report.date = new Date(response.data.date);
            this.formatedDate= format(new Date(this.report.date), 'dd/MM/yyyy')
            // ADD TASKS ARRAY
            this.report.workers.forEach((w) => {
              if (!w.tasks) this.$set(w, "tasks", []);
            });
            // ADD IS SELECTED PROPERTY AND ITEMS COUNT TO ALL MATERIALS ADDED TO THE REPORT
            this.updateMaterials();
            this.updateWorkers();
            // ADD IS SELECTED PROPERTY AND ITEMS COUNT TO ALL ACTIVITIES ADDED TO THE REPORT
            this.updateActivities();
            // ADD IS SELECTED PROPERTY AND ITEMS COUNT TO ALL MECHANIZATIONS ADDED TO THE REPORT
            this.updateMechanizations();
            // ADD IS SELECTED PROPERTY AND ITEMS COUNT TO ALL MECHANIZATIONS ADDED TO THE REPORT
            this.updateRentedMechanizations();
            if (this.report.isInvalid) {
              this.allowSave = false;
              this.$snotify.warning(
                "Грешните отчети не могат да бъдат редактирани!"
              );
            }

            if (this.report.planned) {
              if (this.$route.query.plan !== "true") {
                this.$router.push({ query: { plan: "true" } });
              }
              setTimeout(() => {
                this.isConvertPlannedToRealReportOpen = true;
              }, 1000);
            } else {
              if (this.$route.query.plan === "true") {
                this.$router.push({ query: {} });
              }
            }
          });
        })
        .catch((error) => console.log(error));
    },
  },
  mounted() {
    this.getReport();
  },
};
</script>

<style scoped>
.new-report {
  padding: 10px 20px;
  -webkit-transition: background-color 0.3s;
  -moz-transition: background-color 0.3s;
  -ms-transition: background-color 0.3s;
  -o-transition: background-color 0.3s;
  transition: background-color 0.3s;
  pointer-events: none;
  /* user-select: none; */
}
.new-report--planned {
  background-color: #ece0c6;
  min-height: calc(100vh - 40px);
}
.new-report--flash {
  animation: flash 2s forwards;
}
@keyframes flash {
  0% {
    background-color:var(--color-main);
  }
  20% {
    background-color: #ece0c6;
  }
  40% {
    background-color:var(--color-main);
  }
  60% {
    background-color: #ece0c6;
  }
  80% {
    background-color:var(--color-main);
  }
  100% {
    background-color: transparent;
  }
}
.heads {
  align-items: center;
  display: flex;
  justify-content: flex-start;
}
.title {
  margin-left: 0.5em;
}
.italic {
  font-style: italic;
}
.italic::placeholder {
  font-style: italic;
}
.italic::-moz-placeholder {
  font-style: italic;
}
.italic:-moz-placeholder {
  font-style: italic;
}
.italic:-ms-input-placeholder {
  font-style: italic;
}
.italic::-webkit-input-placeholder {
  font-style: italic;
}
/* .desktop { */
/* display: flex; */
/* } */
.mobile {
  display: none;
}
.icon--date {
  color: #212121;
}
.icon--company {
  color: #d67e00;
}
.icon--project {
  color: #a1260d;
}
.icon-notVisible {
  color: #a1260d;
  cursor: pointer;
  font-size: 18px;
  font-weight: normal;
  position: initial;
}
.icon--delete {
  margin-left: -18px;
}
.name-buttons-wrapper {
  align-items: center;
  background: #dce4e9 0% 0% no-repeat padding-box;
  border-radius: 2px;
  color: #005a9e;
  display: flex;
  height: 20px;
  justify-content: space-between;
  padding: 3px 5px;
  margin-right: 150px;
  width: 390px;
}
.tasks-buttons {
  align-items: center;
  display: flex;
  gap: 5px;
  justify-content: center;
}
.tasks-buttons .mck {
  color: #005a9e;
  cursor: pointer;
  font-size: 13px;
}
.tasks-buttons .toggle-tasks {
  font-size: 20px;
}
.add-remove {
  align-items: center;
  display: flex;
  gap: 3px;
}
.tasks {
  color: #000;
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 5px 0 5px 80px;
  position: relative;
}
.tasks input {
  background: #e8e8e8 0% 0% no-repeat padding-box;
  border-radius: 4px;
  border: 0;
  height: 20px;
  padding: 5px 15px 5px 25px;
  position: relative;
  margin-right: 180px;
  width: 367px;
}
.tasks .tasks-hours-selection {
  display: flex;
  gap: 25px;
  position: relative;
}
.tasks .tasks-hours-selection .select-hour {
  position: relative;
  z-index: 1;
}
.tasks .tasks-hours-selection .select-hour::after {
  background: #e8e8e8;
  content: "";
  height: 1.5px;
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 0;
  width: 29px;
  z-index: -1;
}
.tasks .tasks-hours-selection::before {
  content: "";
  position: absolute;
  left: -15px;
  top: -30px;
  background: #e8e8e8;
  height: calc(230% - 9px);
  width: 1.5px;
  z-index: 1;
}
.tasks .tasks-hours-selection::after {
  content: "";
  position: absolute;
  left: 50%;
  top: -30px;
  background: #e8e8e8;
  width: 1.5px;
  height: calc(230% - 10px);
  z-index: 1;
}
.number {
  align-items: center;
  background: #176fbf 0% 0% no-repeat padding-box;
  border-radius: 50%;
  color: white;
  display: flex;
  font-size: 8px;
  justify-content: center;
  height: 11px;
  padding: 7px;
  width: 11px;
  z-index: 1;
}
.tasks .number {
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 12px;
}
.tasks .tasks-input-wrapper {
  align-items: center;
  display: flex;
  position: relative;
  width: fit-content;
}
.tasks-input-wrapper::after {
  background: #e8e8e8;
  content: "";
  height: 1.5px;
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 0;
  width: 29px;
}
.tasks::before {
  content: "";
  position: absolute;
  left: 65px;
  top: -5px;
  background: #e8e8e8;
  width: 1.5px;
  height: calc(100% - 10px);
  z-index: 1;
}
.icon-isVisible {
  color: #6bbf0b;
}
.no-user-select {
  align-items: center;
  display: flex;
  gap: 5px;
  margin: 3px 0 3px 0.5rem;
  user-select: none;
}
.new-wrapper--controlls .new-input-wrapper {
  margin-right: 5px;
  width: 200px;
}
.new-wrapper--controlls .new-input {
  margin: 0;
}
.new-wrapper--controlls .new-input-dropdown {
  top: calc(100% + 5px);
}
.new-wrapper--controlls .new-content-data-item-toggle {
  align-items: center;
  background-color: #deecf9;
  color: #005a9e;
  font-size: 11px;
  font-weight: 500;
  display: inline-flex;
  height: 35px;
  justify-content: space-between;
  padding: 0 5px;
  width: 130px;
}
.new-wrapper--controlls .new-content-data-item-toggle .mck,
.new-wrapper--controlls .new-content-data-item-toggle .mck2 {
  font-size: 16px;
  font-weight: 400;
}
.new-wrapper--controlls .new-content-data-item-toggle p {
  line-height: 0.9rem;
  text-align: right;
}
.new-wrapper--controlls
  .new-content-data-item:not(.new-content-data-item--transparent)
  .new-content-data-item-toggle:hover {
  background-color: #005a9e;
  color: #fff;
}
.new-content-data-item {
  margin-right: 5px;
}
.new-content-data-item:last-child {
  margin-right: 0;
}
.new-wrapper--controlls
  .new-content-data-item--transparent
  .new-content-data-item-toggle {
  cursor: default;
  opacity: 0.5;
}
.date {
  cursor: pointer;
}
.indicator-display {
  align-items: center;
  display: flex;
  height: 40px;
  justify-content: space-between;
  padding: 5px 15px 5px 40px;
}
.indicator-inactive {
  background-color: #c4c4c4;
}
.new-wrapper--controlls {
  justify-content: space-between;
}
.new-content-inputs {
  width: initial;
}
.new-wrapper--content {
  margin-top: 10px;
}
.help-img {
  width: 100%;
}
.new-wrapper-invalid {
  background-color: #fff8f8;
}
.invalid-report-wrap {
  align-items: center;
  /* background-color: #f4f4f4; */
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  padding: 10px;
}
.invalid-report-wrap .switch-wrapper {
  align-items: center;
  display: flex;
}
.invalid-report-wrap .switch {
  margin: 0;
}
.invalid-report-wrap .switch-label {
  align-items: center;
  display: flex;
}
.invalid-report-wrap .slider {
  background-color: #c4c4c4;
}
.invalid-report-wrap input:checked + .slider {
  background-color: #c50613;
}
.invalid-report-wrap .flag {
  height: 24px;
  margin: 0 8px;
}
.invalid-report-wrap > p {
  padding-right: 20px;
}
.title .flag {
  height: 24px;
  vertical-align: baseline;
  margin: 0 5px;
}
.title span {
  display: inline-flex;
  align-items: center;
}
.link {
  color: #0078d7 !important;
  display: inline-block;
  margin-left: 20px;
  text-decoration: underline;
}
.link:hover {
  opacity: 0.7;
}

.new-content-data-item-content {
  padding: 0;
}
.new-content-data-row {
  border-top: 0;
  margin-top: 0;
  padding-top: 0;
}
.new-content-data-row-active .new-content-data-item-toggle {
  display: table-header-group;
}
.new-content-data-item.expense {
  background-color: rgba(255, 205, 210, 0.2);
}
.new-content-data-item.expense .new-content-data-item-toggle {
  background-color: #ffcdd2;
}
.new-content-data-item.expense .new-content-data-item-toggle:hover {
  background-color: rgba(255, 205, 210, 0.8);
  color: #000;
}
.new-content-data-item.income {
  background-color: rgba(220, 237, 200, 0.2);
}
.new-content-data-item.income .new-content-data-item-toggle {
  background-color: #dcedc8;
}
.new-content-data-item.income .new-content-data-item-toggle:hover {
  background-color: rgba(220, 237, 200, 0.8);
  color: #000;
}
.new-content-data-item-toggle tr {
  display: table-row;
}
.new-content-data-item-content {
  overflow: auto;
  width: 100%;
}
.new-content-data-item-content table {
  border-collapse: collapse;
  width: 100%;
}
.new-content-data-item-content tbody {
  padding: 10px;
}
.new-content-data-item-content thead tr td {
  padding: 10px;
}
.new-content-data-item-content tbody tr td {
  color: #000;
  font-size: 11px;
}
.new-content-data-item-content tr td {
  padding: 1px 10px;
  min-width: 125px;
  vertical-align: middle;
}
.new-content-data-item-content .part-tr td {
  color: #000;
  font-size: 14px;
  font-weight: 700;
  padding-top: 10px;
}
.new-content-data-item-content .part-tr td:first-child {
  color: #005a9e;
}
.new-content-data-item-content .part-tr .part-name-span {
  text-transform: uppercase;
  position: relative;
}
.new-content-data-item-content .part-tr .part-name-span::before {
  content: "i";
  font-family: "mck";
  left: -20px;
  position: absolute;
  text-transform: lowercase;
  top: 50%;
  transform: translateY(-50%);
}
.new-content-data-item-content .part-tr td:first-child {
  text-align: left;
}
.new-content-data-item-content tr .padding-right {
  padding-right: 30px;
}
.new-content-data-item-content table tr td.no-min {
  min-width: initial;
  text-align: left;
}
.new-content-data-item-content tr td:first-child {
  width: 100%;
}
.new-content-data-item-content tr td:last-child {
  min-width: initial;
}
.new-content-data-item-content tr td:not(:first-child) {
  white-space: nowrap;
}
.new-content-data-item-content tr td:not(:first-child) {
  text-align: right;
}
.new-content-data-item-content thead tr td:first-child {
  border-top-left-radius: 4px;
  white-space: nowrap;
}
.new-content-data-item-content thead tr td:last-child {
  border-top-right-radius: 4px;
}
.new-content-data-item-content tbody tr:first-child td {
  padding-top: 10px;
}
.new-content-data-item-content tbody tr:last-child td {
  padding-bottom: 10px;
}
.new-content-data-item-content tbody tr td:first-child {
  padding-left: 30px;
}
.new-content-data-item-content tbody tr td:last-child {
  text-align: right;
}
.new-content-data-row-active .new-content-data-item-toggle-circle {
  position: relative;
  right: 0;
  top: 10px;
}
.new-content-data-item-toggle-circle .mck {
  margin: 0;
}
.new-content-data-item-content tbody .tr-totals td {
  color: #373737;
  font-weight: 700;
  font-size: 14px;
  padding-top: 10px;
  text-align: right;
}
.new-content-data-item-content tbody .tr-totals td:first-child {
  padding-right: 0;
  text-align: left;
}
.new-content-data-item-content tbody .tr-totals td:last-child {
  padding-left: 0;
}
.tr-totals__expense {
  color: #db0000;
}
.tr-totals__income {
  color: #2b7500;
}
.tr-totals__balance {
  color: #000;
}
.new-content-data-item-content
  tbody
  .tr-totals
  td:not(:last-child):not(:first-child) {
  padding-left: 0;
  padding-right: 0;
}
.new-content-data-item-content tbody .tr-totals td:last-child p {
  padding-left: 20px;
}
.new-content-data-item-content tbody .tr-totals td p {
  border-top: 1px solid #9c9c9c;
  padding-top: 10px;
}
.ma-cell-name .mck {
  bottom: 3px;
  left: 10px;
  transform: initial;
  top: initial;
}
.input-and-percent-wrapper {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.total-wrapper {
  align-items: center;
  background-color: #eeeeee;
  border-radius: 4px;
  display: flex;
  font-weight: 700;
  justify-content: space-between;
  margin-bottom: 5px;
  padding: 10px 10px 10px 30px;
  width: 100%;
}
.total-wrapper--red {
  background-color: #ffcdd2;
}
.total-wrapper--green {
  background-color: #dcedc8;
}
.worker-hours-toggle {
  cursor: pointer;
  font-size: 18px;
  line-height: 18px;
  margin-right: 5px;
  vertical-align: middle;
  -webkit-transition: color 0.3s;
  -moz-transition: color 0.3s;
  -ms-transition: color 0.3s;
  -o-transition: color 0.3s;
  transition: color 0.3s;
}
.worker-hours-toggle:hover {
  color: #0073e6;
}
.hidden {
  opacity: 0;
}
/* Responsive */
@media screen and (max-width: 1280px) {
  .indicator-display {
    padding-right: 2px;
  }
  .indicator-display .indicators {
    display: inline-flex;
  }
  .indicator-display .worktime-indicator {
    height: 34px;
    margin: 0 2px;
    width: 14px;
  }
  .indicator-display .worktime-indicator span {
    transform: rotate(-90deg);
    font-size: 9px;
    white-space: nowrap;
    font-weight: 700;
  }
}
@media screen and (max-width: 1000px) {
  .mobile {
    display: flex;
    width: 100%;
    flex-direction: row;
  }
  .new-report {
    padding: 10px 15px;
  }
  .new-content-inputs.desktop,
  .desktop {
    display: none;
  }
  .new-content {
    width: 100%;
  }
  .new-content-inputs.mobile {
    display: flex;
    flex-direction: column;
  }
  .new-input-wrapper {
    width: 100%;
  }
  /* .new-input.mobile.drop {
    padding: 15px;
  } */
  .new-content-inputs {
    flex-direction: column;
  }
  .date-irv-wrapper {
    display: flex;
    width: 100%;
  }
  .datepicker-dropdown-active {
    width: 210%;
  }
  .start-end-wrapper {
    display: flex;
    width: 100%;
  }
  .new-content-data-item-toggle.mobile {
    text-align: center;
    /* flex-direction: column; */
    height: auto;
    padding-bottom: 0.6em;
  }
  .new-content-data-row-toggles {
    flex-wrap: wrap;
  }
  .new-content-data-item-small {
    width: calc(50% - 10px);
    margin: 0;
  }
  .new-content-data-item-small:nth-child(2n) {
    margin-left: 20px;
  }
  .new-content-data-item-small:nth-child(1n + 3) {
    margin-top: 20px;
  }
  .new-content-data-item-small .new-content-data-item-toggle.mobile {
    flex-direction: column;
  }
  .new-content-data-item-toggle.mobile p {
    margin-top: 0.6em;
    margin-bottom: 0.6em;
    margin-right: 0px;
  }
  .new-content-data-item-content {
    overflow: auto;
  }
  .new-content-data-item-content .ma-cell,
  .new-content-data-item-content .users-cell,
  .new-content-data-item-togle .ma-cell {
    padding: 0px 10px 0 0;
  }
  .new-content-data-item-content .ma-cell-additional {
    padding-left: 15px;
  }
  .new-content-data-item-content .ma-cell-nowrap {
    white-space: nowrap;
  }
  .new-content-data-item-content .users-cell p {
    display: flex;
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    margin-right: 0px;
  }
  .date,
  .indicator-display {
    height: 51px;
  }
  .label {
    color: #373737;
    font-size: 11px;
    font-weight: 700;
  }
}
@media screen and (max-width: 600px) {
  .invalid-report-wrap {
    flex-direction: column;
  }
  .invalid-report-wrap > p {
    padding: 0 0 15px;
    text-align: center;
  }
}
</style>
